var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 12,
    height: 9,
    rx: 3,
    stroke: "#6B8299",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V4C11 2.34315 9.65685 1 8 1V1C6.34315 1 5 2.34315 5 4V6",
    stroke: "#6B8299",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.84615C10 9.86576 9.10457 10.6923 8 10.6923C6.89543 10.6923 6 9.86576 6 8.84615C6 7.82655 6.89543 7 8 7C9.10457 7 10 7.82655 10 8.84615Z",
    fill: "#6B8299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.76923C7 9.25943 7.44772 8.84615 8 8.84615C8.55228 8.84615 9 9.25943 9 9.76923V12.0769C9 12.5867 8.55228 13 8 13C7.44772 13 7 12.5867 7 12.0769V9.76923Z",
    fill: "#6B8299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.05a20cc03bc9f3c24f0ffea74c60c0e4.svg";
export { ForwardRef as ReactComponent };